module.exports = __webpack_public_path__ + "assets/img/footer1.957b0aff.png";